<footer class="site-footer">
  <div class="site-footer__inner">
    <h2 class="site-footer__lead">Quer conhecer mais sobre o trabalho da Loba Cria?</h2>
    <p class="site-footer__text">
      Estratégia, conteúdo, branding e soluções criativas para marcas e negócios.
    </p>
    <app-pill-button
      label="Conhecer a Loba"
      variant="dark"
      href="https://lobacria.com.br"
      [external]="true"
    />
    <p class="site-footer__copy">
      &copy; {{ year }}
      <span class="site-footer__brand">Loba Cria</span>. Todos os direitos reservados.
    </p>
  </div>
</footer>
